import React from 'react';

import { useOfferComment } from '../../hook/useOfferComment';
import { OfferCommentsContainer, OfferCommentsHeading, OfferCommentsMeta, OfferCommentsText } from './OfferComments.styles';

const OfferComments: React.FC = () => {
    const offerComment = useOfferComment();

    if (!offerComment) return null;

    const { comment, meta } = offerComment;

    return (
        <OfferCommentsContainer data-testid="offer-comments-display">
            <OfferCommentsHeading size="large" weight="bold">
                Offer Comments
            </OfferCommentsHeading>
            {meta && (
                <OfferCommentsMeta size="xsmall" weight="regular" data-testid="offer-comments-meta">
                    {meta}
                </OfferCommentsMeta>
            )}
            <OfferCommentsText size="small" weight="regular" data-testid="offer-comments-text">
                {comment}
            </OfferCommentsText>
        </OfferCommentsContainer>
    );
};

export default OfferComments;
